// Technical Support page English translations

export default {
  pageTitle: "Technical Support",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "Technical Support",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Expert Technical Support Services",
  description1: "Our technical support team at PT Eagle Industry Indonesia provides comprehensive assistance to ensure optimal performance of our products throughout their lifecycle. With deep expertise in mechanical seals and precision components, our specialists are committed to resolving technical challenges and maximizing equipment reliability for our customers.",
  description2: "We understand that critical operations require immediate and effective technical solutions. Our support team combines theoretical knowledge with practical field experience to deliver prompt assistance that minimizes downtime and extends equipment service life.",
  
  // Services section
  servicesTitle: "Our Technical Support Services Include:",
  services: [
    "24/7 emergency technical assistance for critical applications",
    "On-site troubleshooting and problem diagnosis",
    "Installation guidance and supervision",
    "Performance optimization recommendations",
    "Failure analysis and root cause identification",
    "Technical training for customer maintenance teams",
    "Remote monitoring and diagnostic services"
  ],
  
  // Specialized support section
  specializedTitle: "Specialized Support Areas:",
  specializedDescription: "Our technical support covers all product categories including mechanical seals, stern tube seals, floating seals, lip seals, and specialized valves. We have dedicated specialists for different industry applications, ensuring that you receive support from professionals who understand your specific operational environment and challenges.",
  
  // Metrics
  responseTime: "Response Time",
  responseTimeDesc: "Rapid response with 24/7 availability for critical issues",
  technicalExpertise: "Technical Expertise",
  technicalExpertiseDesc: "Specialists with extensive industry-specific knowledge",
  problemResolution: "Problem Resolution",
  problemResolutionDesc: "Systematic approach to identify and resolve root causes",
  globalSupport: "Global Support",
  globalSupportDesc: "Consistent technical assistance across all operating regions",
  
  // Process section
  processTitle: "Our Support Process:",
  processDescription: "When you contact our technical support team, we follow a structured approach to ensure efficient problem resolution. This includes initial assessment, remote diagnosis when possible, on-site support for complex issues, and follow-up to verify solution effectiveness. We maintain detailed documentation of all support interactions to build knowledge and improve future service delivery.",
  
  // Resources section
  resourcesTitle: "Technical Resources:",
  resourcesDescription: "In addition to direct support, we provide comprehensive technical documentation, installation guides, maintenance procedures, and troubleshooting manuals. Our digital resources include detailed product specifications, compatibility charts, and best practice guidelines to help our customers achieve optimal performance from our products.",
  
  // CTA button
  contactSupport: "Contact Technical Support",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  afterSalesServiceDesc: "Comprehensive after-sales support to ensure customer satisfaction.",
  customManufacturingDesc: "Tailored manufacturing solutions to meet specific customer requirements.",
  qualityAssuranceDesc: "Rigorous quality control processes ensuring international standards compliance.",
  readMore: "Read more"
};